window.addEventListener("load", () => {

  if (typeof gsap === "undefined") return;

  gsap.registerPlugin(ScrollTrigger);

  // =========================
  // AUTO ADD GSAP CLASSES FIRST
  // =========================
  document.querySelectorAll(".text-block.h1").forEach((el) => {
    el.classList.add("gsap-zoom-in");
  });

  document.querySelectorAll(".text-block.h2").forEach((el) => {
    el.classList.add("gsap-zoom-in");
  });

  document.querySelectorAll(".text-block p").forEach((el) => {
    el.classList.add("gsap-fade-up");
  });

  document.querySelectorAll(".custom-typography").forEach((el) => {
    el.classList.add("gsap-fade-up");
  });

  document.querySelectorAll(".button, .button-secondary").forEach((el) => {
    el.classList.add("gsap-fade-up");
  });

  // =========================
  // FADE UP
  // =========================
  gsap.utils.toArray(".gsap-fade-up").forEach((el) => {

    gsap.set(el, {
      opacity: 0,
      y: 60,
      willChange: "transform, opacity"
    });

    gsap.to(el, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "power3.out",
      delay: parseFloat(el.dataset.delay) || 0,

      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true,
        invalidateOnRefresh: true,
      },

      clearProps: "willChange"
    });
  });

  // =========================
  // FADE LEFT
  // =========================
  gsap.utils.toArray(".gsap-fade-left").forEach((el) => {

    gsap.set(el, {
      opacity: 0,
      x: 100,
      willChange: "transform, opacity"
    });

    gsap.to(el, {
      x: 0,
      opacity: 1,
      duration: 2,
      ease: "power3.out",
      delay: parseFloat(el.dataset.delay) || 0,

      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true,
      },

      clearProps: "willChange"
    });
  });

  // =========================
  // FADE RIGHT
  // =========================
  gsap.utils.toArray(".gsap-fade-right").forEach((el) => {

    gsap.set(el, {
      opacity: 0,
      x: -100,
      willChange: "transform, opacity"
    });

    gsap.to(el, {
      x: 0,
      opacity: 1,
      duration: 2,
      ease: "power3.out",
      delay: parseFloat(el.dataset.delay) || 0,

      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true,
      },

      clearProps: "willChange"
    });
  });

  // =========================
  // FADE ONLY
  // =========================
  gsap.utils.toArray(".gsap-fade-only").forEach((el) => {

    gsap.set(el, {
      opacity: 0,
      willChange: "opacity"
    });

    gsap.to(el, {
      opacity: 1,
      duration: 0.8,
      ease: "power1.out",
      delay: parseFloat(el.dataset.delay) || 0,

      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true,
      },

      clearProps: "willChange"
    });
  });

  // =========================
  // CLIP VERTICAL
  // =========================
  gsap.utils.toArray(".gsap-clip-vertical").forEach((el) => {

    gsap.set(el, {
      clipPath: "inset(100% 0% 0% 0%)",
      willChange: "clip-path"
    });

    gsap.to(el, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 1,
      ease: "expo.out",
      delay: parseFloat(el.dataset.delay) || 0,

      scrollTrigger: {
        trigger: el,
        start: "top 80%",
        once: true,
      },

      clearProps: "willChange"
    });
  });

  // =========================
  // CLIP HORIZONTAL
  // =========================
  gsap.utils.toArray(".gsap-clip-horizontal").forEach((el) => {

    gsap.set(el, {
      clipPath: "inset(0% 100% 0% 0%)",
      willChange: "clip-path"
    });

    gsap.to(el, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 1.2,
      ease: "expo.out",
      delay: parseFloat(el.dataset.delay) || 0,

      scrollTrigger: {
        trigger: el,
        start: "top 80%",
        once: true,
      },

      clearProps: "willChange"
    });
  });

  // =========================
  // ZOOM IN
  // =========================
  gsap.utils.toArray(".gsap-zoom-in").forEach((el) => {

    gsap.set(el, {
      scale: 0.92,
      opacity: 0,
      force3D: true,
      willChange: "transform, opacity"
    });

    gsap.to(el, {
      scale: 1,
      opacity: 1,
      duration: 3,
      ease: "power3.out",
      delay: parseFloat(el.dataset.delay) || 0,

      scrollTrigger: {
        trigger: el,
        start: "top 88%",
        once: true,
      },

      clearProps: "willChange"
    });
  });

  // =========================
  // ROTATE IN
  // =========================
  gsap.utils.toArray(".gsap-rotate-in").forEach((el) => {

    gsap.set(el, {
      rotate: 8,
      y: 40,
      opacity: 0,
      willChange: "transform, opacity"
    });

    gsap.to(el, {
      rotate: 0,
      y: 0,
      opacity: 1,
      duration: 1.1,
      ease: "power3.out",
      delay: parseFloat(el.dataset.delay) || 0,

      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true,
      },

      clearProps: "willChange"
    });
  });

  // =========================
  // BLUR TEXT
  // =========================
  gsap.utils.toArray(".gsap-blur-text").forEach((el) => {

    if (el.splitInstance) {
      el.splitInstance.revert();
    }

    const split = new SplitType(el, {
      types: "words, chars",
      tagName: "span",
    });

    el.splitInstance = split;

    gsap.set(split.chars, {
      opacity: 0,
      filter: "blur(6px)",
      y: 15,
      willChange: "filter, opacity, transform"
    });

    gsap.to(split.chars, {
      opacity: 1,
      filter: "blur(0px)",
      y: 0,
      stagger: 0.025,
      duration: 0.7,
      ease: "power2.out",

      scrollTrigger: {
        trigger: el,
        start: "top 80%",
        once: true,
      },

      clearProps: "willChange"
    });
  });

  // =========================
  // REFRESH
  // =========================
  ScrollTrigger.refresh();
});

// =========================
// SIMPLE BLUR REVEAL
// =========================
gsap.utils.toArray(".gsap-blur-reveal").forEach((el) => {

  gsap.set(el, {
    opacity: 0,
    filter: "blur(20px)",
    y: 40,
    willChange: "transform, opacity, filter"
  });

  gsap.to(el, {
    opacity: 1,
    filter: "blur(0px)",
    y: 0,
    duration: 1.4,
    ease: "expo.out",

    scrollTrigger: {
      trigger: el,
      start: "top 85%",
      once: true,
    },

    clearProps: "willChange"
  });

});

// =========================
// RESIZE OPTIMISATION
// =========================
let resizeTimer;

window.addEventListener("resize", () => {

  clearTimeout(resizeTimer);

  resizeTimer = setTimeout(() => {

    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }

  }, 200);
});